import Cookies from 'js-cookie';
import { FrameworkService } from '@/services/framework.service';
import { StateService } from '@/services/state.service';
import { CartApi } from '@/apis/cart.api';
import { UxRegistrationsApi } from '@/apis/uxRegistrations.api';
import _ from 'lodash';
import { Helpers } from '@/common/helpers';


function isBase64(str) {
	if (str ==='' || str.trim() ==='') { return false; }
	try {
		return window.btoa(window.atob(str)) === str;
	} catch {
		return false;
	}
}

export const ReservationService = {

	props: {
		regMode: null,
		eventId: null,
		resourceId: null,
		activityIds: null,
		start: null,
		modifyRegId: null,
		editMode: false,
		duration: null
	},

	initialize() {
		this.props.eventId = StateService.getQuery('eventId');
		this.props.modifyRegId = StateService.getQuery('modify');
		this.props.resourceId = StateService.getQuery('resourceId');
		this.props.activityIds = StateService.getQuery('activityIds');
		this.props.start = StateService.getQuery('start');
		this.props.memberId = StateService.getQuery('memberId');
		this.props.duration = StateService.getQuery('duration');

		if (this.props.memberId) {
			if (Array.isArray(this.props.memberId)) {
				this.props.memberId = _.map(this.props.memberId, (id) => parseInt(id, 10));
			} else {
				this.props.memberId = [parseInt(this.props.memberId, 10)];
			}
		}

		this.props.regMode = this.props.resourceId && this.props.start ? 'resource' : null;
		this.props.regMode = !this.props.regMode && this.props.eventId ? 'event' : this.props.regMode;
		if (this.props.modifyRegId) this.props.editMode = true;
	},

	getRequest(regId) {
		return UxRegistrationsApi.getRequest(this.props.regMode, regId);
	},

	postRequest() {
		if (this.props.editMode) {
			return UxRegistrationsApi.getEventAttendee(this.props.regMode, this.props.eventId, this.props.modifyRegId, this.props.memberId[0]);
		}

		let body = {};
		if (this.props.regMode === 'resource') {
			body = {
				resourceId: this.props.resourceId,
				start: this.props.start,
				service: this.props.activityIds,
				duration: this.props.duration
			};
		} else {
			body = {
				eventId: this.props.eventId,
				memberId: this.props.memberId
			};
		}
		return UxRegistrationsApi.postRequest(this.props.regMode, body);
	},

	putAttendee(regId, attendeeId, duration, spot) {
		let body = {};
		if (this.props.regMode === 'resource') {
			body = { duration: duration };
		} else {
			body = { spot: spot };
		}
		return UxRegistrationsApi.putAttendee(this.props.regMode, body, regId, attendeeId);
	},

	putExtend(regId) {
		return UxRegistrationsApi.putExtend(this.props.regMode, regId);
	},

	putComplete(regId, waiverIds, participants, recaptchaToken, recaptchaSiteKey, recaptchaVersion) {
		let body = {};

		const memberIds = participants.map(p => p.memberId);

		if (this.props.regMode === 'resource') {
			body = {
				acceptedDocuments: waiverIds
			};
		} else {
			body = {
				memberId: memberIds,
				acceptedDocuments: waiverIds
			};
		}

		if (recaptchaToken) {
			var recaptchaHeaders = {
				'x-ltf-captcha-token': recaptchaToken,
				'x-ltf-captcha-sitekey': recaptchaSiteKey,
				'x-ltf-captcha-version': recaptchaVersion
			};
			return UxRegistrationsApi.putCompleteWithCaptcha(this.props.regMode, regId, body, recaptchaHeaders);
		} else {
			return UxRegistrationsApi.putComplete(this.props.regMode, regId, body);
		}
	},

	deleteCancel(regId) {
		return UxRegistrationsApi.deleteCancel(this.props.regMode, regId);
	},

	deleteCancelAttendee(regMode, attendeeId) {
		return UxRegistrationsApi.deleteCancelAttendee(regMode, attendeeId);
	},

	buildCart(cartData) {
		this.initialize();
		return CartApi
			.buildCart(cartData)
			.then(response => {
				const metadata = response.data.Entries?.[0]?.Metadata ?? [];
				const isExerpPosCart = metadata.find(m => m.Key === 'IsExerpPosCart')?.Value === 'True';
				return { cartId: response.data.Id, isExerpPosCart };
			});
	},

	createCart(cartData) {
		this.initialize();
		return CartApi
			.createCart(cartData)
			.then(response => {
				return response.data.Id;
			});
	},
	addRemainingCart(cartId, cartData) {
		this.initialize();
		if (cartData.participants.length > 1) {
			return CartApi.addRemaining(cartData, cartId).then(responses => {
				for (const response of responses) {
					if (!response.ok) return false;
				}
				return true;
			});
		}
		return Promise.resolve(true);
	},
	pendingStoreAsCookie(data) {
		data.agreement = null;
		data.validation = null;
		Cookies.set('pendingResPaid', JSON.stringify(data));
	},
	getCancelUrl() {
		if (Helpers.isDev()) return '/canceled.html';

		let cancelUrl = StateService.getQuery('cancelUrl') || FrameworkService.facilitiesUrl();
		if (cancelUrl && isBase64(cancelUrl)) {
			cancelUrl = window.atob(cancelUrl);
		}
		return cancelUrl;
	}
};
